const SALT = '81ef47a727bdfb4a84955f96e734195f34b7cfcf4b28d53b7157999ad8566408';

export default SALT;
